import React, { useEffect, useMemo, useRef } from 'react';
import { useReactiveVar } from '@apollo/client';

import { useRouterState } from 'app/hooks/useRouterState';
// NETWORKING
import { subscriptionInfoPopupTransitionVar } from 'app/apollo/reaction';

// CM
import { MobilePortionsSelectContainer } from 'app/components/Select';
import Loader from 'app/components/Loader';
import OverlaysContainer from 'app/components/OverlaysContainer';
import DishesSelection from 'app/components/DishesSelection/DishesSelection';
import { DeliveryDateDialogContainer } from 'app/components/Dialog';
import SubscriptionInfoPopup from 'app/components/infoPopup/SubscriptionInfoPopup';
import PushNotificationsPopup from 'app/components/PushNotificationsPopup';
import MainPopUpAndDialog from './MainPopUpAndDialog';

interface IPropsFromMain {
    overlayIsOpen: boolean
    onClickOpenBasket: () => void
    openedModal: 'delivery-info' | 'recurrent-info' | 'address-info' | 'default'
    popUpUiState: 'recurrent-info' | 'address-info' | 'default'
    showModalOverlay: boolean
    showMobilePortions: boolean
    handleCloseMobilePortions: () => void
    mobilePortionsInfo: any
    showPushNotificationPopup: boolean
    onAcceptPushNotifications: () => void
    onClosePushNotificationsPopup: () => void
}

const BasketSubscriptionInfoPopup = () => {
    const { location: { pathname } } = window;
    const transition = useReactiveVar<string>(subscriptionInfoPopupTransitionVar);
    const ref = useRef(null);

    const backdrop = useMemo(() => {
        const match = pathname.match(/\/(basket|checkout)(?=\/|$)/);
        return match ? 'clear' : 'blur';
    }, [pathname]);

    useEffect(() => {
        if (ref.current) {
            // @ts-expect-error
            ref.current.onClose = () => {
                subscriptionInfoPopupTransitionVar('exited');
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <aside-panel
            // @ts-expect-error
            style={{ '--z-index': 6004 }}
            backdrop={backdrop}
            transition={transition}
            ref={ref}
        >
            <SubscriptionInfoPopup
                onClose={() => { subscriptionInfoPopupTransitionVar('exited'); }}
            />
        </aside-panel>
    );
};


export const MainPopups = React.memo((props: IPropsFromMain) => {
    const {
        onClickOpenBasket,
        overlayIsOpen,
        openedModal,
        showModalOverlay,
        popUpUiState,
        showMobilePortions = false,
        handleCloseMobilePortions,
        mobilePortionsInfo,

        showPushNotificationPopup,
        onAcceptPushNotifications,
        onClosePushNotificationsPopup,
    } = props;

    const [{ location }] = useRouterState();

    return (
        <>
            <BasketSubscriptionInfoPopup />
            {/* TODO: Убрать это из main. Перенести выбор порций в карточку блюда */}
            <MobilePortionsSelectContainer
                // @ts-expect-error isSelectRequired boolean
                isSelectRequired={showMobilePortions}
                info={mobilePortionsInfo}
                onClose={handleCloseMobilePortions}
            />
            <MainPopUpAndDialog
                openedModal={openedModal}
                showModalOverlay={showModalOverlay}
                popUpUiState={popUpUiState}
            />
            {/*
            {/* Dialog containers */}
            <DeliveryDateDialogContainer />
            {/* Нода для монтирования компонентов, использующих библиотеку react-portal.
                Нужна, чтобы эти компоненты не рендерились в конце боди и не перекрывали оверлеи из OverlaysContainer */}
            <OverlaysContainer />
            <Loader />
            <DishesSelection
                location={location}
                overlayIsOpen={overlayIsOpen}
                onClickOpenBasket={onClickOpenBasket}
            />
            <div id="react-portal-mount-node" />
            {showPushNotificationPopup && (
                <PushNotificationsPopup
                    onClickAccept={onAcceptPushNotifications}
                    onClickClose={onClosePushNotificationsPopup}
                />
            )}
            {/* deprecated BR-1112 */}
            {/* {allowRenderMobileStreet && showMobileStreet && (
                <Overlay
                    overlayOpen={!!showMobileStreetOverlay}
                    onClick={this.handleCloseMobileStreet}
                    // onClick={this.handleCloseMobileStreet}
                    animateEnter={animateEnterOverlay}
                    animateExit={animateExitOverlay}
                    onExited={this.onMobileStreetClosed}
                    onEntered={this.disableEnterOverlayAnimation}
                >
                    <MobileStreet
                        info={mobileStreetInfo}
                        onClose={this.handleCloseMobileStreet}
                    />
                </Overlay>
            )} */}
            {/* deprecated BR-1112 */}
            {/* <DateTimeConfirmDialogContainer
                    isDialogRequired={showDateTimeConfirmDialog}
                    type={dateTimeConfirmDialogType}
                    hasExtraText={isDateTimeConfirmDialogExtraText}
                    onConfirmOne={this.handleDateTimeConfirmOne}
                    onConfirmAll={this.handleDateTimeConfirmAll}
                    onReject={this.handleDateTimeReject}
            /> */}
            {/* deprecated BR-1112 */}
            {/* <AddressConfirmDialogContainer
                    isDialogRequired={showAddressConfirmDialog}
                    hasExtraText={isAddressConfirmDialogExtraText}
                    onConfirmOne={this.handleAddressConfirmOne}
                    onConfirmAll={this.handleAddressConfirmAll}
                    onReject={this.handleAddressReject}
                />
            */}
            {/* deprecated BR-1112 */}
            {/* <MobileTimeSelectContainer
                    isSelectRequired={showMobileTimeIntervals}
                    isDelivery={mobileTimeIntervalsInfo.deliveryId}
                    info={mobileTimeIntervalsInfo}
                    onClose={this.handleCloseMobileTimeIntervals}
                />
            */}
        </>
    );
});
